import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KnowledgeModule } from '@app/modules/knowledge/knowledge.module';
import { DialogUpdateListingListedStatusComponent } from '@app/modules/properties/components/dialog-update-listing-listed-status/dialog-update-listing-listed-status';

import { SharedModule } from '@app/shared/shared.module';
import { CreateBookingListingDialogComponent } from './components/create-booking-listing-dialog/create-booking-listing-dialog.component';
import { DialogAddIcalComponent } from './components/dialog-add-ical/dialog-add-ical.component';
import { DialogParentChildPropertySetupComponent } from './components/dialog-parent-child-property-setup/dialog-parent-child-property-setup.component';
import { DialogParentChildRemoveRelationshipConfirm } from './components/dialog-parent-child-remove-relationship-confirm/dialog-parent-child-remove-relationship-confirm.component';
import { DialogPropertyOpportunitiesComponent } from './components/dialog-property-opportunities/dialog-property-opportunities.component';
import { DialogRemoveListingComponent } from './components/dialog-remove-listing/dialog-remove-listing.component';
import { DialogSetLeadListingComponent } from './components/dialog-set-lead-listing/dialog-set-lead-listing.component';
import { ParentChildRelationshipVisualiser } from './components/parent-child-relationship-visualiser/parent-child-relationship-visualiser.component';
import { PropertyDetailAmenitySelectionComponent } from './components/property-detail-amenity-selection/property-detail-amenity-selection.component';
import { PropertyDetailDescriptionEditComponent } from './components/property-detail-description-edit/property-detail-description-edit.component';
import { PropertyDetailDetailsComponent } from './components/property-detail-details/property-detail-details.component';
import { PropertyDetailIcalsComponent } from './components/property-detail-icals/property-detail-icals.component';
import { PropertyDetailLanguageSelectionComponent } from './components/property-detail-language-selection/property-detail-language-selection.component';
import { PropertyDetailMergeMatchComponent } from './components/property-detail-merge-match/property-detail-merge-match.component';
import { PropertyDetailMessagingRulesComponent } from './components/property-detail-messaging-rules/property-detail-messaging-rules.component';
import { PropertyDetailNumberEditBooleanEditComponent } from './components/property-detail-number-edit-boolean-edit/property-detail-number-edit-boolean-edit.component';
import { PropertyDetailNumberEditComponent } from './components/property-detail-number-edit/property-detail-number-edit.component';
import { PropertyDetailPayoutsComponent } from './components/property-detail-payouts/property-detail-payouts.component';
import { PropertyDetailResyncDialogComponent } from './components/property-detail-resync-dialog/property-detail-resync-dialog.component';
import { PropertyDetailShortcodes } from './components/property-detail-shortcodes/property-detail-shortcodes.component';
import { PropertyDetailSubnavComponent } from './components/property-detail-subnav/property-detail-subnav.component';
import { PropertyDetailDirectComponent } from './components/sbnb-property-detail-direct/sbnb-property-detail-direct.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { PropertiesComponent } from './pages/properties/properties.component';
import { PropertyIsInParentChildSetupPipe } from './pages/properties/property-is-in-parent-child-setup/property-is-in-parent-child-setup.pipe';
import { PropertyAvailabilityRulesComponent } from './pages/property-availability-rules/property-availability-rules.component';
import { PropertyDetailComponent } from './pages/property-detail/property-detail.component';
import { AmenityLabelPipe } from './pipes/amenity-label/amenity-label.pipe';
import { ListBookingListingsRoomIdsPipe } from './pipes/list-booking-listings-room-ids/list-booking-listings-room-ids.pipe';
import { ParentChildSetupSortPropertiesParentFirstPipe } from './pipes/parent-child-setup-sort-properties-parent-first/parent-child-setup-sort-properties-parent-first.pipe';
import { PropertiesRoutingModule } from './properties-routing.module';

// Standalone imports
import { PropertyUpdateStatusComponent } from '@app/features/properties';
import {
  PropertyFeesTaxesDiscountsComponent,
  PropertyBookingRatePlansComponent,
  PropertyAvailabilityRulesFormComponent,
  PropertyListingMarkupsComponent,
  PropertyBasePriceComponent,
} from '@app/features/pricing-and-availability';

@NgModule({
  declarations: [
    DialogParentChildPropertySetupComponent,
    DialogParentChildRemoveRelationshipConfirm,
    DialogRemoveListingComponent,
    DialogSetLeadListingComponent,
    DialogUpdateListingListedStatusComponent,
    DialogAddIcalComponent,
    DialogPropertyOpportunitiesComponent,
    PropertiesComponent,
    PropertyDetailComponent,
    PropertyDetailSubnavComponent,
    PropertyDetailMergeMatchComponent,
    PropertyDetailMessagingRulesComponent,
    PropertyDetailIcalsComponent,
    AmenityLabelPipe,
    PropertyDetailDetailsComponent,
    PropertyDetailDescriptionEditComponent,
    PropertyDetailLanguageSelectionComponent,
    PropertyDetailAmenitySelectionComponent,
    PropertyDetailResyncDialogComponent,
    PropertyDetailNumberEditComponent,
    PropertyDetailPayoutsComponent,
    PropertyDetailNumberEditBooleanEditComponent,
    PropertyDetailDirectComponent,
    ParentChildSetupSortPropertiesParentFirstPipe,
    PropertyDetailShortcodes,
    ParentChildRelationshipVisualiser,
    ListBookingListingsRoomIdsPipe,
    PropertyIsInParentChildSetupPipe,
    PropertyAvailabilityRulesComponent,
    CreateBookingListingDialogComponent,
    ClickOutsideDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    KnowledgeModule,
    PropertiesRoutingModule,
    PropertyAvailabilityRulesFormComponent,
    PropertyBasePriceComponent,
    PropertyListingMarkupsComponent,
    PropertyBookingRatePlansComponent,
    PropertyUpdateStatusComponent,
    PropertyFeesTaxesDiscountsComponent,
  ],
})
export class PropertiesModule {}
